"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPromoCode = exports.getReferral = exports.getReferralByCountry = exports.getCoupon = exports.getAllCoupons = exports.getRawCoupons = exports.getGlobalCouponByCountry = exports.getCouponByCountry = exports.getCoupons = void 0;
var reselect_1 = require("reselect");
var selectors_1 = require("../cart/shippingCountry/selectors");
var getCoupons = function (state) { return state.ejsCoupons; };
exports.getCoupons = getCoupons;
exports.getCouponByCountry = (0, reselect_1.createSelector)(exports.getCoupons, function (coupons) {
    return coupons.currentCouponByCountry;
});
exports.getGlobalCouponByCountry = (0, reselect_1.createSelector)(exports.getCoupons, function (coupons) {
    return coupons.currentGlobalCouponByCountry;
});
exports.getRawCoupons = (0, reselect_1.createSelector)(selectors_1.getShippingCountry, exports.getCouponByCountry, exports.getGlobalCouponByCountry, function (shippingCountry, couponByCountry, globalCouponByCountry) {
    var currentCoupon = couponByCountry[shippingCountry];
    var currentGlobalCoupon = globalCouponByCountry[shippingCountry];
    return [currentCoupon, currentGlobalCoupon].filter(function (coupon) { var _a; return !!coupon && ((_a = coupon.data) === null || _a === void 0 ? void 0 : _a.country) === shippingCountry; });
});
exports.getAllCoupons = (0, reselect_1.createSelector)(selectors_1.getShippingCountry, exports.getRawCoupons, function (shippingCountry, rawCoupons) {
    var couponCanApply = function (coupon) {
        if (!coupon || !coupon.data) {
            return false;
        }
        var country = coupon.data.country;
        if (country !== shippingCountry) {
            return false;
        }
        return true;
    };
    var allCoupons = rawCoupons
        .filter(couponCanApply)
        .map(function (coupon) { return (__assign({}, coupon)); });
    return allCoupons;
});
exports.getCoupon = (0, reselect_1.createSelector)(exports.getAllCoupons, function (allCoupons) {
    var _a;
    return (_a = allCoupons[0]) === null || _a === void 0 ? void 0 : _a.data;
});
exports.getReferralByCountry = (0, reselect_1.createSelector)(exports.getCoupons, function (coupons) {
    return coupons.currentReferralByCountry;
});
exports.getReferral = (0, reselect_1.createSelector)(selectors_1.getShippingCountry, exports.getReferralByCountry, function (shippingCountry, currentReferralByCountry) {
    var currentReferral = currentReferralByCountry[shippingCountry];
    if (currentReferral && currentReferral.data.country !== shippingCountry) {
        return null;
    }
    return currentReferral;
});
exports.getPromoCode = (0, reselect_1.createSelector)(exports.getCoupons, function (coupons) {
    return coupons.promoCode;
});
